<template>
  <!-- 下单冲榜 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="box-content-order">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <div class="card-point">
          <div class="card-rule">
            <i class="el-alert__icon el-icon-info"></i>
            <div>官方规则：</div>
          </div>
          <div class="card-connet">
            <p>1、订单完成后发放奖励</p>
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="160px"
        >
          <div class="newsInfo">基本信息</div>
          <template>
            <el-form-item label="活动名称:" required>
              <el-input
                v-model="ruleForm.activityName"
                maxlength="50"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 400px"
                :disabled="isStartEdit"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                  :disabled="isStartEdit"
                  :default-time="
                    this.$getDate(30)[0].substring(
                      11,
                      this.$getDate(30)[0].length
                    )
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValueEnd"
                  :default-time="
                    this.$getDate(30)[0].substring(
                      11,
                      this.$getDate(30)[0].length
                    )
                  "
                  :clearable="false"
                  :disabled="isStartEdit"
                >
                </el-date-picker>
                <i
                  v-if="!isStartEdit"
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
                <span style="color: #2670fb">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
            <el-form-item label="活动对象：" required>
              <el-radio-group
                v-model="ruleForm.activityObject"
                :disabled="isStartEdit"
                @change="handleActivityObj"
                  style="margin-right: 16px"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">指定身份</el-radio>
                <el-radio :label="2" disabled>指定人群</el-radio>
              </el-radio-group>
              <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button
                  slot="reference"
                  disabled
                  >{{
                    peopleList.length == 0
                      ? "选择人群"
                      : `已选${peopleList.length}个`
                  }}</el-button
                >
              </el-popover>
            </el-form-item>
            <el-form-item
              label="新老客户："
              required
              v-if="ruleForm.activityObject == '1'"
            >
              <el-radio-group
                v-model="ruleForm.newOldCustomer"
                :disabled="isStartEdit"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">新客</el-radio>
                <el-radio :label="2">老客</el-radio>
              </el-radio-group>
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
                </div>
                <div
                  class="cursorPointer"
                  style="
                    display: inline-block;
                    margin-left: 16px;
                    font-size: 12px;
                    color: #999;
                  "
                >
                  <span>新老客说明</span>
                  <i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="参与对象:" prop="partner">
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="isStartEdit"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  :label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="nowType == 'look' || (nowType == 'edit' && activityData.status == 2)"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

            <el-form-item label="活动条件:">
              <el-checkbox v-model="ruleForm.condFollow" :disabled="isStartEdit"
                >关注后方可参与活动</el-checkbox
              ></el-form-item
            >
            <div class="newsInfo">入榜规则</div>
            <el-form-item label="开榜时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  class="startTime"
                  prefix-icon="no_icon"
                  v-model="ruleForm.showRankTime"
                  type="datetime"
                  placeholder="选择日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 400px; font-size: 12px"
                  default-time="00:00:00"
                  :clearable="false"
                  :picker-options="scoresOrderStart"
                  :disabled="isStartEdit"
                >
                </el-date-picker>
                <i
                  v-if="!isStartEdit"
                  class="el-icon-circle-close date_icon1"
                  @click="clearScoresTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label="兑奖时间:" required>
              <div
                v-if="ruleForm.showRankTime && ruleForm.activityEndTime"
                class="prizeTime-wrap"
              >
                <div>{{ ruleForm.showRankTime }}</div>
                <div class="time_to_text">~</div>
                <div>{{ ruleForm.activityEndTime }}</div>
              </div>
              <div v-else>
                <span>-</span>
              </div>
              <div class="form-tip-wrap">
                <span class="memberTips"
                  >入榜用户需要在此时间段内领奖，超时无效</span
                >
              </div>
            </el-form-item>
            <el-form-item label="最低入榜的金额:" required>
              <el-input
                v-model="ruleForm.minRankAmount"
                maxlength="15"
                placeholder="请输入最低入榜的金额"
                style="width: 400px"
                :disabled="isStartEdit"
                @input="ruleForm.minRankAmount = getNumberData($event, 1, 0)"
              ></el-input>
              <span style="padding-left: 8px">元</span>
              <div class="form-tip-wrap">
                <span class="memberTips"
                  >入榜排行根据 用户总实付金额(收货)
                  进行统计，用户需大于设定金额才能入榜</span
                >
              </div>
            </el-form-item>
            <el-form-item label="订单规则:" required>
              <div class="rule_box">
                <div class="rule_box_top">所下订单需满足如下条件</div>
                <div class="rule_box_middle">
                  <el-form-item label="下单时间:" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                        :disabled="isStartEdit"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                        :disabled="isStartEdit"
                      >
                      </el-date-picker>
                      <i
                        v-if="!isStartEdit"
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom">
                  <el-form-item label="指定购买商品:" required>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      :disabled="isStartEdit"
                      label="0"
                    >
                      全部商品
                    </el-radio>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="isStartEdit"
                      >指定商品</el-radio
                    >
                    <el-button
                      :disabled="
                        ruleForm.filterType == '0' ||
                        ruleForm.filterType == '2' ||
                        isStartEdit
                      "
                      :style="{
                        width: itemListForFilter.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <el-radio
                      style="margin-left: 30px"
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      :disabled="isStartEdit"
                      >排除商品</el-radio
                    >
                    <el-button
                      :disabled="
                        ruleForm.filterType == '0' ||
                        ruleForm.filterType == '1' ||
                        isStartEdit
                      "
                      :style="{
                        width: itemListForFilter1.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter1.length != ""
                          ? "已选择" + "(" + itemListForFilter1.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <div class="form-tip-wrap">
                      <span class="memberTips"
                        >选择指定商品，用户订单中内有一件指定商品时则整笔计算<br
                      /></span>
                      <span class="memberTips"
                        >选择排除商品，用户订单中全部为排除商品时订单将不计算；用户订单内有一件非排除商品时，只算非排除商品部分。</span
                      >
                    </div>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom">
                  <el-form-item label="金额统计方式:" required>
                    <el-radio
                      v-model="ruleForm.moneyCountType"
                      :disabled="isStartEdit"
                      :label="0"
                    >
                      按累计金额
                    </el-radio>
                    <div class="form-tip-wrap">
                      <span class="memberTips"
                        >累计金额：用户在制定下单时间内符合条件的
                        所有订单金额总和</span
                      >
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>

            <div class="newsInfo">阶梯与奖品设置</div>
            <el-form-item label="名次规则:" required>
              <el-radio v-model="rulesType" :label="1" :disabled="isStartEdit"
                >按阶梯</el-radio
              >
            </el-form-item>
            <el-form-item label="名次奖品设置:" required>
              <div>规则说明：</div>
              <div>
                1、如按阶梯配置多个奖品，则用户只需满足不同阶梯之间的差额，即有机会获得对应位置的奖品;
              </div>
              <div>2、同一位置的奖品，每名用户只能领取一次;</div>
              <div>
                3、因为每名用户同一位置的奖品限能领取一次，所以在同一位配置几份奖品，即表示能覆盖排行榜几名的位置(例如在位置1共配置了5份奖品A，则表明排行榜前的5名的用户，可获得奖品A);
              </div>
              <div>
                4、若出现消费金额相同的情况，将按照参与时间的先后顺序进行排名;
              </div>
              <div>
                5、排行榜位置最多可配置5个，每个位置最多可容纳100个用户。
              </div>
              <div class="newCard">
                <div class="prize_box">
                  <el-form-item label="奖品设置:" required label-width="100px">
                    <div class="form-tip-wrap">
                      <span class="memberTips"
                        >1、至订单完成后发放奖励，整个活动期内每人每个名次只可领取1次及其中一个奖品。<br
                      /></span>
                      <span class="memberTips"
                        >2、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</span
                      >
                    </div>
                  </el-form-item>
                  <el-table
                    :header-cell-style="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#FAFAFA',
                    }"
                    :cell-style="{
                      'text-align': 'center',
                      overflow: 'visible',
                    }"
                    :data="classList"
                    border
                    style="width: 1150px; overflow: visible"
                  >
                    <el-table-column prop="date" label="序号" width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="排名" width="140px">
                      <template slot-scope="scope">
                        <span>{{ getClass(scope) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="奖品类型"
                      min-width="150px"
                    >
                      <template slot-scope="scope">
                        <div>
                          <el-button
                            style="width: auto"
                            key="2"
                            :disabled="isStartEdit"
                            type="text"
                            v-if="scope.row.prizeType"
                            @click="centerVis2(scope)"
                            >{{ scope.row.prizeType | prizeType }}</el-button
                          >
                          <el-button
                            v-else
                            key="3"
                            @click="centerVis2(scope)"
                            type="text"
                            >选择奖品</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="奖品名称"
                      min-width="200px"
                    >
                      <template slot-scope="scope">
                        <div>
                          <span
                            v-if="
                              scope.row.prizeType == 3 ||
                              scope.row.prizeType == 10
                            "
                            style="width: auto; white-space: normal"
                          >
                            {{ scope.row.title }}
                          </span>
                          <span v-else-if="scope.row.prizeType">{{
                            scope.row.prizeType | prizeType
                          }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          :disabled="isStartEdit"
                          @input="
                            scope.row.prizeCount = getNumberData(
                              $event,
                              0,
                              1,
                              100
                            )
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="logo"
                      width="200"
                      label="奖品展示图片"
                    >
                      <template slot-scope="scope">
                        <div class="btnGroup1">
                          <el-image
                            class="elImg"
                            :src="scope.row.logo"
                            fit="contain"
                            style="
                              width: 40px;
                              height: 40px;
                              background: #d9d9d9;
                              border-radius: 4px 4px 4px 4px;
                              margin-right: 10px;
                            "
                          >
                            <div slot="error" class="image-slot"></div>
                          </el-image>
                          <div class="btnGroup">
                            <el-upload
                              :disabled="isStartEdit"
                              class="upload"
                              action="/api/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload3"
                              :on-success="
                                (file) => {
                                  return handleUpload3(file, scope);
                                }
                              "
                            >
                              <el-button
                                :disabled="isStartEdit"
                                type="text"
                                class="text-btn"
                                >上传图片</el-button
                              >
                            </el-upload>
                            <el-button
                              :disabled="isStartEdit"
                              type="text"
                              @click="picUrlReset3(scope)"
                              v-if="scope.row.prizeType != 3"
                              class="text-btn"
                              >重置</el-button
                            >
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column width="100" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          @click="deleteClass(scope.$index)"
                          type="text"
                          :disabled="isStartEdit"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button
                    :disabled="isStartEdit"
                    type="primary"
                    style="margin-top: 8px; width: auto"
                    @click="addClass"
                  >
                    增加排名（{{ classList.length }}/5）
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="C端排行榜显示规则:" required>
              <el-radio
                v-model="ruleForm.showRankType"
                :label="0"
                :disabled="isStartEdit"
                >活动开始后展示</el-radio
              >
              <el-radio
                v-model="ruleForm.showRankType"
                :label="1"
                :disabled="isStartEdit"
                >开榜后展示</el-radio
              >
            </el-form-item>

            <div class="newsInfo">曝光商品</div>
            <el-form-item label="曝光商品:">
              <el-checkbox
                v-model="ruleForm.exposureSwitch"
                @change="exposureSwitchChange"
                :disabled="isStartEdit"
              >
                是否添加曝光商品
              </el-checkbox>
              <el-button
                style="width: 155px; margin: 0 15px; display: inline-block"
                :class="{ add_btn1: ruleForm.exposureSwitch }"
                @click="exposureProducts"
                :disabled="ruleForm.exposureSwitch == false || isStartEdit"
              >
                {{
                  itemListFor.length != ""
                    ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                    : "添加曝光商品"
                }}
              </el-button>
              <draggable
                :disabled="isStartEdit"
                v-if="itemListFor.length > 0"
                v-model="itemListFor"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="
                  margin-top: 10px;
                  background: rgba(38, 112, 251, 0.06);
                  padding: 10px;
                "
              >
                <transition-group type="transition">
                  <div
                    v-for="(item, index) in itemListFor"
                    :key="item.skuId"
                    style="display: inline-block; position: relative"
                    class="show_upImg2"
                  >
                    <img
                      :src="item.logo"
                      width="120px"
                      height="120px"
                      style="display: inline-block"
                    />&nbsp;
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img
                        src="@/assets/thdImg/pages/delet.svg"
                        @click.stop="delec(index)"
                        class="delectIcom"
                      />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <div class="newsInfo">活动规则</div>
            <el-form-item label="规则内容:" required>
              <div
                style="
                  width: 570px;
                  backgroundcolor: rgba(250, 250, 250, 1);
                  padding: 8px;
                  position: relative;
                "
              >
                <el-input
                  :disabled="isStartEdit"
                  type="textarea"
                  class="textarea"
                  style="width: 543px"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :maxlength="2000"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{
                    ruleForm.activityRulesText.length
                      ? ruleForm.activityRulesText.length
                      : 0
                  }}/2000）
                </div>
                <div>
                  <el-button
                    key="generate"
                    :disabled="isStartEdit"
                    type="primary"
                    class="generate"
                    plain
                    @click="generateRule"
                  >
                    生成规则
                  </el-button>

                  <span class="desc">
                    <i class="el-alert__icon el-icon-info"></i>
                    提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                  </span>
                </div>
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="itemListFor"
      :maxNum="20"
    ></selectGoodsMonitor>
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      @transferName="selectGoodsCloseFilter"
      :postForm="itemListForFilter"
    ></selectGoodsMonitor>
    <!-- 排除购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter1"
      @transferName="selectGoodsCloseFilter1"
      :postForm="itemListForFilter1"
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      @choose-shop="getTheData"
      :isShowFirst="false"
    >
    </selectProduct>
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import {
  createOrderRank,
  orderRankDetail,
  updateOrderRank,
} from "@/api/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/integralCenter/integralTask";
import { getTaobaoItemList } from "@/api/public";

export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
  },
  computed: {
    // 获取按阶级排名
    getClass() {
      return (scope) => {
        const count = this.classList
          .slice(0, scope.$index)
          .reduce((pre, next) => {
            return pre + Number(next.prizeCount);
          }, 0);
        // 当前项有值
        if (scope.row.prizeCount) {
          if (count > 0) {
            if (scope.row.prizeCount == 1) {
              return `第${Number(count) + 1}名`;
            } else {
              return `第${Number(count) + 1}名~第${
                Number(count) + Number(scope.row.prizeCount)
              }名`;
            }
          } else {
            if (scope.row.prizeCount == 1) {
              return `第1名`;
            } else {
              return `第1名~第${scope.row.prizeCount}名`;
            }
          }
        } else {
          return "";
        }
      };
    },
    // 查看或进行中活动禁用操作
    isStartEdit() {
      return this.startEdit || this.backgroundOpacity;
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "8") {
        result = "支付宝现金红包";
      } else if (num == "10") {
        result = "实物 (专属下单)";
      }
      return result;
    },
  },
  data() {
    return {
      isShowSelectCrowd: false,
      peopleList: [],

      echoDate: {},
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleForm.activityEndime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      selectGoodsStateFilter: false,
      selectGoodsStateFilter1: false,
      itemListForFilter: [],
      itemListForFilter1: [],
      appointListForFilter: [],
      fromLoading: false, // 数据加载 显示
      levelList: [],
      showDialog: false,
      //开榜时间限制
      scoresOrderStart: {
        disabledDate: (time) => {
          let start = this.ruleForm.activityStartTime
            ? new Date(this.ruleForm.activityStartTime).getTime() -
              24 * 60 * 60 * 1000
            : 0;
          let end = this.ruleForm.activityEndTime
            ? new Date(this.ruleForm.activityEndTime).getTime()
            : Infinity;
          let current = time.getTime();
          if (current > start && current < end) {
            return false;
          } else {
            return true;
          }
        },
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                  new Date(this.ruleForm.orderStartTime).getTime() ||
                time.getTime(time) >
                  new Date(this.ruleForm.orderStartTime).getTime() + day * 30
              );
            } else {
              return (
                time.getTime(time) + day <
                  new Date(this.ruleForm.orderStartTime).getTime() ||
                time.getTime(time) >
                  new Date(this.ruleForm.orderStartTime).getTime() + day * 30
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            const day = 24 * 60 * 60 * 1000;
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.orderEndTime).getTime() - day * 30
            );
          } else {
          }
        },
      },
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      ruleForm: {
        membershipTime:"", // 入会时间
        //设置规则表单
        activityName: "",
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        isLimitSkuAmt: false,
        skuStartPayment: "",
        skuEndPayment: "",
        startTime: "",
        activityStartTime: null,
        activityEndTime: null,
        prizeSite: "",
        information: [],
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 复购 首单 下单
        condFollow: false, // 是否需要关注店铺
        days: "100", //近X天内未购
        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        showRankTime: "", //开榜时间
        minRankAmount: "", //入榜最低金额
        moneyCountType: 0, //金额统计方式

        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是

        isMemberGiftCheck: false,
        isHavePrizes: "2",
        itemList: [], //曝光商品集合
        showRankType: 0,
      },
      priceImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/prizeShow.png", //默认产品图
      couponImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/coupon.png",
      integralImg:
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/yunqihd_B/integral.png",
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      rulesType: 1,
      classList: [
        {
          title: "",
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      uploadSize3: false,
      activityData: {},
      backgroundOpacity: false,
      isSave: true,
      startEdit: false,
      isCopy: false,
      valueRow: {}, //活动id
      templateId: null,
    };
  },
  created() {
    const { activityData } = this.$route.query;
    this.activityData = activityData;
    // 模版id
    if (activityData.templateId) {
      this.templateId = activityData.templateId;
    }
    // 获取会员等级
    this.getLevel();
  },
  methods: {
    //上传图片前校验   按阶级名次奖品图片设置
    beforeUpload3(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        console.log("宽高", image.width, image.height);
        const valid = image.width == 300 && image.height == 300;
        file.isFlag = valid;
        _this.uploadSize3 = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.warning("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.warning("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload3(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (this.uploadSize3) {
          this.$set(scope.row, "logo", res.data);
        }
      }
    },
    // 重置背景图  按阶级名次奖品图片设置
    picUrlReset3(scope) {
      this.$set(scope.row, "logo", this.priceImg);
    },
    // 活动持续时间
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    // 修改 数据回显
    getDetail() {
      orderRankDetail(this.valueRow.id).then((res) => {
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        // 会员回显
        // const allowLevel = res.data.allowLevel.split(",")
        // if(allowLevel.includes("-1")){
        //   this.ruleForm.partner = ["-1"]
        // }else{
        //    this.ruleForm.partner = allowLevel.map(item=>Number(item))
        // }
        this.ruleForm.activityObject = res.data.hasOwnProperty("activityObject")
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty("newOldCustomer")
          ? Number(res.data.newOldCustomer)
          : 0;
        this.peopleList =
          res.data.hasOwnProperty("seniorGroupId") &&
          res.data.seniorGroupId.length > 0
            ? res.data.seniorGroupId.split(",")
            : [];
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        // 奖品
        this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;

        this.ruleForm.orderStartCount = res.data.ruleDto.orderStartCount;
        this.ruleForm.orderEndCount = res.data.ruleDto.orderEndCount;
        this.ruleForm.orderStartPayment = res.data.ruleDto.orderStartPayment;
        this.ruleForm.orderEndPayment = res.data.ruleDto.orderEndPayment;
        this.ruleForm.isLimitSkuAmt = res.data.ruleDto.isLimitSkuAmt;
        this.ruleForm.skuStartPayment = res.data.ruleDto.skuStartPayment;
        this.ruleForm.skuEndPayment = res.data.ruleDto.skuEndPayment;
        this.ruleForm.showRankType =
          String(res.data.ruleDto.showRankType) == 0 ? 0 : 1;

        this.ruleForm.showRankTime = res.data.ruleDto.showRankTime;
        this.ruleForm.minRankAmount = res.data.ruleDto.minRankAmount;

        if (this.ruleForm.isLimitSkuAmt) {
          this.appointListForFilter = res.data.ruleDto.limitSkuList || [];
          this.appointGoodsFilterArr = this.appointListForFilter;
        }

        //复制 在新活动内除奖品设置、活动规则外，其他信息均回显
        if (!this.isCopy) {
          this.templateId = res.data.templateId;
          // 订单规则
          this.ruleForm.filterType = String(res.data.ruleDto.skuType);
          this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
          this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;
          // 奖品回显---start
          // 按排名
          this.rulesType = res.data.ruleDto.rankType;
          this.classList = res.data.prizeDTOList.map((list) => {
            let obj;
            list.pointActivityPrizeDTOList.forEach((item) => {
              obj = {
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                logo: item.logo,
                discount: item.price || item.singleAmount,
                singleAmount: item.singleAmount,
                price: item.price,
                prizeCount: item.totalAmount,
                id: item.id,
              };
              if (item.prizeType == 1) {
                obj.quota = item.quota;
                obj.couponType = item.couponType;
                obj.assetsId = item.batchKey;
              }
            });
            return obj;
          });
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          // 商品
          if (res.data.ruleDto.skuIds && res.data.ruleDto.skuIds.length) {
            getTaobaoItemList({
              pageNum: 1,
              pageSize: 99999,
              numIid: res.data.ruleDto.skuIds.join(","),
            }).then((result) => {
              // 指定购买商品
              if (res.data.ruleDto.skuType == 1) {
                this.itemListForFilter = result.data.dataList.map((item) => {
                  return {
                    ...item,
                    skuId: item.numIid,
                    title: item.itemTitle,
                    logo: item.picUrl,
                    price: item.price,
                  };
                });
              } else if (res.data.ruleDto.skuType == 2) {
                this.itemListForFilter1 = result.data.dataList.map((item) => {
                  return {
                    ...item,
                    skuId: item.numIid,
                    title: item.itemTitle,
                    logo: item.picUrl,
                    price: item.price,
                  };
                });
              }
            });
          }
        }
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        this.itemListFor = res.data.itemList;
        this.activityTimeChange();
      });
    },
    // 奖品弹窗关闭
    colseDialog() {
      this.showDialog = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        res.data.forEach((item) => {
          this.levelList.push(item.customerLevelName);
        });
        if (this.$route.query.valueRow) {
          this.backgroundOpacity =
            this.$route.query.backgroundOpacity == "true" ? true : false;
          this.isSave = this.$route.query.isSave == "true" ? true : false;
          this.startEdit =
            this.$route.query.isStartEdit == "true" ? true : false;
          this.valueRow = this.$route.query.valueRow;
          this.getDetail();
        } else if (this.$route.query.copyParams) {
          // 复制
          this.isCopy = true;
          this.backgroundOpacity = false;
          this.isSave = true;
          this.startEdit = false;
          this.valueRow = this.$route.query.copyParams.valueRow;
          this.getDetail();
        } else {
          // 新增-默认活动时间
          this.ruleForm.activityStartTime = this.$getDate(30)[0];
          this.ruleForm.activityEndTime = this.$getDate(30)[1];
          this.activityTimeChange();
        }
      });
    },
    //选择商品数据 曝光
    getTheData(data, prizeType) {
      console.log(data);
      console.log(prizeType);
      this.showDialog = false;
      // 按阶梯
      this.classList[this.classIndex].prizeType = prizeType;
      this.classList[this.classIndex].price =
        data.discount || data.singleAmount;
      this.classList[this.classIndex].singleAmount = data.singleAmount;
      this.classList[this.classIndex].title = data.name || prizeType;
      this.classList[this.classIndex].assetsId = Number(data.couponId);
      this.classList[this.classIndex].logo = data.logo || this.priceImg;
      // 优惠券
      if (prizeType == 1) {
        this.classList[this.classIndex].quota = data.quota;
        this.classList[this.classIndex].couponType = data.couponType;
        this.classList[this.classIndex].logo = this.couponImg;
        this.classList[this.classIndex].price = data.price;
        this.classList[this.classIndex].assetsId = data.batchKey;
      }
      // 实物
      if (prizeType == 3) {
        this.classList[this.classIndex].skuId = data.skuId;
      }
      // 店铺积分
      // 实物
      if (prizeType == 4) {
        this.classList[this.classIndex].logo = this.integralImg;
      }
      // 实物-专属下单
      if (prizeType == 10) {
        this.classList[this.classIndex].price = data.price;
        this.classList[this.classIndex].assetsId = data.id;
        this.classList[this.classIndex].title = data.itemTitle;
        this.classList[this.classIndex].logo = data.picUrl;
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    // 下单时间
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    // 开榜时间
    clearScoresTime() {
      this.ruleForm.showRankTime = null;
    },
    //删除
    delec(index) {
      this.itemListFor.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.itemListFor.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    // 按阶梯选择奖品类型
    centerVis2(scope) {
      this.classIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.echoDate)
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.activityEndTime) -
              new Date(this.ruleForm.activityStartTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        const date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 返回上一步
    returnBack() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        ruleDTO: {
          orderStartTime: this.ruleForm.orderStartTime,
          orderEndTime: this.ruleForm.orderEndTime,
          showRankTime: this.ruleForm.showRankTime, // 开榜时间
          minRankAmount: this.ruleForm.minRankAmount, //入榜最低金额（元）
          skuType: this.ruleForm.filterType,
          skuIds: [],
          showRankType: this.ruleForm.showRankType,
          rankType: this.rulesType,
        }, //活动名称
        prizeDTOList: [], //奖品列表
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.peopleList.join(","),
        allowLevel: this.ruleForm.partner.join(","),
        itemList: this.itemListFor.map((item) => {
          return {
            skuId: item.skuId,
            title: item.title,
            logo: item.logo,
            price: item.price,
          };
        }), //曝光商品集合
        templateId: this.templateId,
      };

      //会员等级设置
      // 全部
      // if (this.ruleForm.partner.includes("-1")) {
      //   cardParams.allowLevel = "-1";
      // } else {
      //   // 单个会员等级
      //   cardParams.allowLevel = this.ruleForm.partner.join(",");
      // }

      // 购买商品
      if (this.ruleForm.filterType == 1) {
        cardParams.ruleDTO.skuIds = this.itemListForFilter.map(
          (item) => item.skuId
        );
        cardParams.ruleDTO.itemList = this.itemListForFilter.map((item) => {
          return {
            skuId: item.skuId,
            title: item.title,
            logo: item.logo,
            price: item.price,
          };
        });
      } else if (this.ruleForm.filterType == 2) {
        cardParams.ruleDTO.skuIds = this.itemListForFilter1.map(
          (item) => item.skuId
        );
        cardParams.ruleDTO.itemList = this.itemListForFilter1;
      }
      // 名次奖品设置
      // 按阶梯
      cardParams.prizeDTOList = this.classList.map((item, index) => {
        const obj = {
          taskIndex: Number(index + 1),
          pointActivityPrizeDTOList: [],
        };
        let prize = {
          title: item.title,
          assetsId: item.assetsId,
          prizeType: item.prizeType,
          singleAmount: item.singleAmount, //
          totalAmount: item.prizeCount, // 总数额
          price: item.price,
          logo: item.logo,
          id: item.id,
        };
        if (prize.prizeType == 1) {
          prize.batchKey = item.assetsId;
          prize.assetsId = "";
        }
        if (prize.prizeType == 3) {
          prize.logo = item.logo;
          prize.assetsId = item.skuId || item.assetsId;
        }
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
        }
        if (prize.prizeType == 2 || prize.prizeType == 4) {
          prize.singleAmount = item.price;
        } else {
          prize.singleAmount = 1;
        }
        obj.pointActivityPrizeDTOList.push(prize);
        return obj;
      });
      // 曝光商品排序调整
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
      }
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      //活动参与对象限制
      console.log("this.ruleForm.partner", this.ruleForm.partner);
      if (!this.ruleForm.partner || this.ruleForm.partner.length == 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }

      //下单时间不能为空
      if (!this.ruleForm.showRankTime) {
        this.$message.warning("请填写开榜时间！");
        return;
      }

      //下单时间不能为空
      if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
        this.$message.warning("请填写下单时间！");
        return;
      }

      //入榜最低金额不能为空
      if (!this.ruleForm.minRankAmount) {
        this.$message.warning("请填写入榜最低金额！");
        return;
      }

      if (this.ruleForm.filterType == 1) {
        if (this.itemListForFilter.length == 0) {
          this.$message.warning("请添加指定商品！");
          return;
        }
      } else if (this.ruleForm.filterType == 2) {
        if (this.itemListForFilter1.length == 0) {
          this.$message.warning("请添加排除商品！");
          return;
        }
      }
      // 请将奖品填写完整！
      let isFlay = false;
      // 按阶梯
      this.classList.forEach((item) => {
        if (!item.price || !item.prizeCount) {
          isFlay = true;
        }
      });

      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      //活动规则不能为空
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.valueRow.id && !this.isCopy) {
          createOrderRank({ id: this.valueRow.id, ...cardParams }).then(
            (res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                this.$router.push({ path: "activeList1" });
              } else {
                this.$message.error(res.message);
              }
            }
          );
        } else {
          createOrderRank(cardParams).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text5 = "",
        text6 = "",
        test1 = "",
        test2 = "",
        test3 = "",
        test6 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName + ";" + "\n";
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime +
          ";" +
          "\n";
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it.label;
              }
            });
          }
          levelText.push(item);
        });
        text3 = "活动参与对象：" + levelText.splice(",") + ";" + "\n";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      // 参与规则
      // 开榜时间
      if (this.ruleForm.showRankTime) {
        test1 = "开榜时间：" + this.ruleForm.showRankTime + ";" + "\n";
      }
      // 下单时间
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        test2 =
          "下单时间：" +
          this.ruleForm.orderStartTime +
          "~" +
          this.ruleForm.orderEndTime +
          ";" +
          "\n";
      }
      //入榜最低金额
      if (this.ruleForm.minRankAmount) {
        test3 =
          "入榜最低金额：" + this.ruleForm.minRankAmount + "元" + ";" + "\n";
      }
      //指定购买商品
      if (this.ruleForm.filterType) {
        let filter = "";
        if (this.ruleForm.filterType == 1) {
          filter = "指定商品";
        } else if (this.ruleForm.filterType == 2) {
          filter = "排除商品";
        } else {
          filter = "全部商品";
        }
        test6 = "指定购买商品：" + filter + ";" + "\n";
      }
      text6 = "参与规则：" + "\n" + test1 + test2 + test3 + test6;

      //奖品设置
      let text9 = "活动奖品：" + "\n";

      // 按阶梯
      if (this.rulesType == 1) {
        this.classList.forEach((item, index) => {
          const count = this.classList.slice(0, index).reduce((pre, next) => {
            return pre + Number(next.prizeCount);
          }, 0);
          // 当前项有值
          if (item.prizeCount) {
            let name = this.$options.filters.prizeType(item.prizeType);
            // 处理优惠券
            if (item.prizeType == 1) {
              name = "元" + name;
            }
            if (count > 0) {
              if (item.prizeCount == 1) {
                text9 +=
                  `第${Number(count) + 1}名: ${item.price}${
                    item.prizeType == 3 || item.prizeType == 10
                      ? `元#${item.title}`
                      : name
                  }` + "\n";
              } else {
                text9 +=
                  `第${Number(count) + 1}名~第${
                    Number(count) + Number(item.prizeCount)
                  }名: ${item.price}${
                    item.prizeType == 3 || item.prizeType == 10
                      ? `元#${item.title}`
                      : name
                  }` + "\n";
              }
            } else {
              if (item.prizeCount == 1) {
                text9 +=
                  `第1名: ${item.price}${
                    item.prizeType == 3 || item.prizeType == 10
                      ? `元#${item.title}`
                      : name
                  }` + "\n";
              } else {
                text9 +=
                  `第1名~第${item.prizeCount}名: ${item.price}${
                    item.prizeType == 3 || item.prizeType == 10
                      ? `元#${item.title}`
                      : name
                  }` + "\n";
              }
            }
          }
        });
      }
      let Arr1 = [text1, text2, text3,text34, text5, text6, text9];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item;
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 是否添加曝光商品
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
      }
    },
    // 切换指定购买商品
    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.itemListForFilter1 = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      // 根据类型显示商品
      if (this.ruleForm.filterType == 1) {
        this.selectGoodsStateFilter = true;
      } else if (this.ruleForm.filterType == 2) {
        this.selectGoodsStateFilter1 = true;
      }
    },
    // 曝光商品
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    // 指定商品
    selectGoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter = newArr;
        }
      }
      this.selectGoodsStateFilter = false;
    },
    // 排除商品
    selectGoodsCloseFilter1(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListForFilter1 = newArr;
        }
      }
      this.selectGoodsStateFilter1 = false;
    },
    // 活动对象选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    // 上一步
    clickLocalStep() {
      this.$router.go(-1);
    },
    // 按阶级新增
    addClass() {
      if (this.classList.length === 5) {
        this.$message.warning("最多可设置5个阶梯区间");
        return;
      }
      this.classList.push({
        title: "",
        peopleCount: "",
        prizeType: "",
        discount: "",
        prizeCount: "",
        singleAmount: "",
      });
    },
    // 按阶级删除
    deleteClass(index) {
      this.classList.splice(index, 1);
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.text-btn {
  width: auto;
  padding: 0px !important;
  margin-right: 10px;
}
/deep/ .prize_box .el-form-item__label {
  color: red !important;
  font-size: 12px;
}
.prizeTime-wrap {
  display: flex;
  align-items: center;
}
.form-tip-wrap {
  line-height: 26px;
  margin-top: 4px;
  font-size: 12px;
}
.condition {
  font-weight: 700;
  margin-left: 20px;
}

.nong_fu_icon {
  margin-left: 4px;
  padding-top: 2px;
  cursor: pointer;

  .tips {
    display: none;
  }

  &:hover {
    .tips {
      color: red;
      font-size: 14px;
      display: inline-block;
      margin-left: 12px;
    }
  }
}

.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #2670fb;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.btnGroup {
  display: flex;
  justify-content: space-around;
  align-items: center;
  &_button {
    color: #2670fb;
    cursor: pointer;
  }
}
.btnGroup1 {
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 150px;
  top: 65%;
  transform: translate(0, -50%);
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 1000px;
  // height: 217px;
  background: #fafafa;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #2670fb;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    width: 90px;
    display: flex;
    align-items: center;
    i {
      color: #2670fb;
      margin-right: 3px;
    }
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 8px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #2670fb;
    border: 1px solid #2670fb;
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(123, 97, 255, 0.1);
    border-radius: 4px;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: calc(100vh - 60px - 24px - 59px);
  background-color: #fff;
  border-radius: 6px;
  margin: 24px 24px 0px;
  .box-content-order {
    height: calc(100% - 70px);
    overflow-y: auto;
  }
  .create_bottom {
    background-color: #fff;
  }
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #2670fb;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #2670fb;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 10px 30px;
      background: #f4f7ff;
      font-size: 13px;
      color: #333;
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #2670fb;
      }
    }
    .set {
      display: inline-block;
      // margin-top: 30px;
    }
    .desc {
      margin-left: 8px;
      color: #999;
      font-size: 13px;
      i {
        // color: #fe8f8a;
        // opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2670fb;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    // /deep/ .el-table .el-table__header-wrapper th .cell {
    //   // text-align: center;
    //   font-weight: 500;
    // }
    // /deep/ .el-table .el-table__header-wrapper th {
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
    // /deep/ .el-table--enable-row-transition .el-table__body td {
    //   text-align: center;
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2670fb;
        border-bottom: 1px solid #2670fb;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2670fb;
        border-left: 1px solid #2670fb;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #2670fb;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #2670fb;
      &:hover {
        color: #fff;
        background: #2670fb;
      }
    }
    .reset {
      color: #2670fb;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.newCard {
  width: 1150px;
  margin: 20px 0 0 0;
  /deep/.el-tabs__header {
    margin: 0;
  }
  /deep/.el-tabs__content {
    border: 1px solid #d3dce6;
    border-top: 0;
  }
  /deep/.el-tabs__new-tab {
    color: #2670fb;
    border: 1px solid #2670fb;
    width: 25px;
    height: 25px;
    margin: 8px 0 0 0;
    line-height: 25px;
    font-size: 18px;
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
